module.exports = __webpack_public_path__ + "img/preview-5.c9af0973.png";